import AcProfileDetailsTab from './details/details';
import AcProfileSettingsTab from './settings/settings';
import AcProfileSecurityTab from './security/security';

export default {
  Details: AcProfileDetailsTab,
  Settings: AcProfileSettingsTab,
  Security: AcProfileSecurityTab,
};
